import { render, staticRenderFns } from "./InteractiveVideo.vue?vue&type=template&id=5a030b45&scoped=true"
import script from "./InteractiveVideo.vue?vue&type=script&lang=js"
export * from "./InteractiveVideo.vue?vue&type=script&lang=js"
import style0 from "./InteractiveVideo.vue?vue&type=style&index=0&id=5a030b45&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a030b45",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a030b45')) {
      api.createRecord('5a030b45', component.options)
    } else {
      api.reload('5a030b45', component.options)
    }
    module.hot.accept("./InteractiveVideo.vue?vue&type=template&id=5a030b45&scoped=true", function () {
      api.rerender('5a030b45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/curriculum-manage/InteractiveVideo.vue"
export default component.exports